import { GettingStartedStep } from "../GettingStartedStep";
import { ISetup } from "@smartrr/shared/entities/Organization";

export class MigrationStep extends GettingStartedStep {
  getOrder(): number {
    return 1;
  }

  protected deriveCompleted(setup: ISetup): boolean {
    return Boolean(setup.onSiteSetup?.migrationService?.completed);
  }
}
